import {useIsFocused} from '@react-navigation/native';
import React, {useEffect, useState} from 'react';
import {FlatList} from 'react-native';

import {Header} from '../../../components/Interface/Headers/Header';
import {Loading} from '../../../components/Interface/Loadings/Loading';

import {api} from '../../../services/api';

import {Container, Content} from './styles';
import {RFValue} from 'react-native-responsive-fontsize';
import {Titles} from '../../../components/Interface/Typographies/Titles';
import {BaratinhaItemDTO} from '../../../dtos/PaymentItemDTO';
import {BaratinhaItem} from '../../../components/shared/Payments/BaratinhaItem';
import {NotFound} from '../../../components/Interface/Search/NotFound';
import {getStatusBarHeight} from 'react-native-iphone-screen-helper';

export function BaratinhasHistory() {
  const isFocused = useIsFocused();

  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState<BaratinhaItemDTO[]>(
    [] as BaratinhaItemDTO[],
  );

  useEffect(() => {
    let isMounted = true;

    async function fetchPayments() {
      setIsLoading(true);
      setIsError(false);

      try {
        await api.get('/extratoBaratinhas').then(response => {
          if (isMounted) {
            setData(response.data);
            setIsLoading(false);

            isMounted = false;
          }
        });
      } catch (error) {
        if (isMounted) {
          setIsLoading(false);
          setIsError(true);
          isMounted = false;
        }
        console.log(error);
      } finally {
        if (isMounted) {
          setIsLoading(false);
          isMounted = false;
        }
      }
    }

    fetchPayments();

    return () => {
      isMounted = false;
    };
  }, [isFocused]);

  return (
    <Container>
      {isLoading && <Loading />}
      <Header icon="chevron-left" />

      <Content>
        {isError && (
          <NotFound
            style={{
              marginTop: -getStatusBarHeight(),
            }}
            pointerEvents="box-none"
            title="Ocorreu um problema"
            text="Não conseguimos listar seu extrato de baratinhaZ."
          />
        )}
        {data.length !== 0
          ? !isError && (
              <>
                <Titles title="BaratinhaZ" />
                <FlatList
                  data={data}
                  keyExtractor={(e: any) => e.id}
                  style={{
                    marginHorizontal: -24,
                  }}
                  renderItem={({item}) => <BaratinhaItem data={item} />}
                  showsVerticalScrollIndicator={false}
                  contentContainerStyle={{
                    paddingBottom: RFValue(20),
                  }}
                />
              </>
            )
          : !isLoading &&
            !isError && (
              <NotFound
                style={{
                  marginTop: -getStatusBarHeight(),
                }}
                pointerEvents="box-none"
                title="Nenhuma baratinhaZ encontrada"
                text="Você pode acumular baratinhaZ com cashback e indique e ganhe."
              />
            )}
      </Content>
    </Container>
  );
}
